import { useStyle } from "../style";
import { SvgIcon } from "@mui/material";
import contactIconImg from "@static/img/dashboard/contact.svg";

export const ContactIcon = () => {
    const { classes } = useStyle({});

    return <SvgIcon className={classes.iconBox} component={contactIconImg} viewBox="0 0 30 30" />;
};
